import makeStyles from '@material-ui/styles/makeStyles';

export default makeStyles({
  textSecondary: {
    color: 'white',
    fontWeight: 700
  }
});
